import styled from "@emotion/styled";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, InputAdornment } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthData } from "auth/AuthWarpper";
import DataTable from "utils/DataTable/DataTable";
import NoData from "assets/noData.svg";
import ViewButton from "utils/ViewButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ClearIcon from "@mui/icons-material/Clear";
import labels from "utils/lables.json";
import ImportService from "services/ImportService";
import ImportSubGrowerService from "services/ImportSubGrowerService";
import CustomPagination from "../Common/CustomPagination";

const ViewLogSubGrower = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const params = useParams();
  const { id } = params;
  const dataPrev = location.state;

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");

  const columns = [
    {
      field: "subGrowerCode",
      headerName: "Sub Grower Code",
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <span style={{ padding: "20px" }}>{params.value}</span>
      ),
    },
    {
      field: "subGrowerFullName",
      headerName: "Sub Grower Full Name",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "subGrowerRegion",
      headerName: "Sub Grower Region",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "subGrowerLocation",
      headerName: "Sub Grower Location",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "propertyNumber",
      headerName: "Property Number",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "subGrowerStatus",
      headerName: "Sub Grower Status",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cropYear",
      headerName: "Crop Year",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cropSeason",
      headerName: "Crop Season",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <span style={{ color: params.value === "Fail" ? "red" : "green" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "operation",
      headerName: "Operation",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "errorDescription",
      headerName: "Error Description",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "View Details",
      width: 120,
      headerAlign: "left",
      align: "left",
      getActions: (params) => {
        const state = {
          id: params.id,
          subGrowerCode: params.row.subGrowerCode,
          subGrowerTempId: params.row.subGrowerTempId,
          subGrowerFullName: params.row.subGrowerFullName,
          subGrowerRegion: params.row.subGrowerRegion,
          subGrowerLocation: params.row.subGrowerLocation,
          phoneNumber: params.row.phoneNumber,
          propertyNumber: params.row.propertyNumber,
          subGrowerStatus: params.row.subGrowerStatus,
          cropYear: params.row.cropYear,
          cropSeason: params.row.cropSeason,
          status: params.row.status,
          operation: params.row.operation,
          errorDescription: params.row.errorDescription,
        };
        const url = `/viewSubGrowerDetails/${params.id}`;
        return [<ViewButton state={state} url={url} />];
      },
    },
  ];

  const paginate = (pageNumber, itemsPerPage) => {
    callSubGrowerAPI(pageNumber - 1, itemsPerPage);
  };

  useEffect(() => {
    callSubGrowerAPI(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage, statusFilter]);

  const callSubGrowerAPI = (pNumber, size) => {
    setLoading(true);
    const query = {
      id: id,
      pageNumber: pNumber,
      size: size,
      status: statusFilter ? (statusFilter === "All" ? "" : statusFilter) : undefined,
    };

    ImportSubGrowerService.FetchAllSubGrowerViewLog(query)
      .then((res) => {
        const logs = res?.data?.response?.importSubGrowerLogs || [];
        const mappedData = logs.map((item) => ({
          sgLogId: item["sub-grower-log-id"],
          subGrowerCode: item["permanent-code"],
          subGrowerFullName: item["sub-grower-name"],
          subGrowerRegion: item["region"],
          subGrowerLocation: item["location"],
          phoneNumber: item["phone-number"],
          propertyNumber: item["property-number"],
          subGrowerStatus: item["status"],
          cropYear: item["crop-year"],
          cropSeason: item["crop-season"],
          operation: item["operation"],
          status: item["import-status"],
          errorDescription: item["error-description"],
        }));
        setCurrentPage(pNumber);
        setItemsPerPage(size);
        setData(mappedData);
        setTotalItems(res?.data?.response?.totalItems || 0);
      })
      .catch((error) => {
        setData([]);
        console.error("API call failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExportAll = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id });
      if (response.status !== 200) {
        throw new Error("Network response was not ok");
      }
      const BOM = "﻿";
      const fileContent = BOM + response.data;
      const blob = new Blob([fileContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "sub_grower_log.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <Layout title={labels.pageTitle}>
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>Import Sub Grower</Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            {labels.backButton}
          </Button>
        </Box>

        <PaperContainer>
          <form autoComplete="off">
            <Grid container spacing={2}>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", sx: "block" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="fileName">
                  {labels.fileNameLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={dataPrev?.fileName ?? ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", xs: "block" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="uploadedBy">
                  {labels.uploadedByLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={dataPrev?.uploadedBy ?? ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", xs: "none" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="uploadStatus">
                  {labels.uploadStatusLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={dataPrev?.uploadStatus ?? ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", sx: "block" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="comments">
                  {labels.commentsLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={dataPrev?.comments ?? ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", sx: "block" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="timestamp">
                  {labels.timestampLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={dataPrev?.timestamp ?? ""}
                  disabled
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{ display: { md: "flex", xs: "flex" }, alignItems: "center" }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="successFail">
                  {labels.successFailLabel}
                </InputLabel>
                <TextField
                  sx={{ width: { xs: "100%", md: "14rem" } }}
                  value={`${dataPrev?.success ?? 0}/${dataPrev?.fail ?? 0}`}
                  disabled
                />
              </Grid>
            </Grid>
          </form>
        </PaperContainer>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <FormControl sx={{ m: 1, minWidth: { xs: 150, md: 200 }, minHeight: 50 }}>
              <TextField
                select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label={statusFilter ? "" : "Status"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div onClick={() => setStatusFilter("")}>
                        <ClearIcon
                          sx={{
                            mt: 0.5,
                            mr: 2,
                            cursor: "pointer",
                            visibility: statusFilter !== "" ? "visible" : "hidden",
                          }}
                        />
                      </div>
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Success">{labels.successOption}</MenuItem>
                <MenuItem value="Fail">{labels.failOption}</MenuItem>
              </TextField>
            </FormControl>
          </Box>

          <Button
            sx={{
              borderRadius: 2,
              minWidth: 156,
              minHeight: 44,
              background: "#EF7D00",
              "&:hover": { background: "#EF7D00" },
            }}
            startIcon={loading && <CircularProgress size={20} />}
            variant="contained"
            onClick={handleExportAll}
            disabled={loading}
          >
            {labels.exportButton}
          </Button>
        </Box>

        <Box>
          {data.length !== 0 ? (
            <DataTable
              getRowId={(row) => row.sgLogId}
              data={data}
              rows={data}
              columns={columns}
              hideFooter={true}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={NoData} style={{ height: "100px" }} alt="No Data" />
              <p>{labels.noDataMessage}</p>
            </Box>
          )}
        </Box>
      </div>

      {data.length !== 0 && (
        <Box>
          <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
            <CustomPagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={(v) => setItemsPerPage(v)}
              totalItems={totalItems}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </Box>
      )}
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

export default ViewLogSubGrower;
